import request from '@/utils/request'

// 获取验证码
export function getCaptcha(params) {
  return request({
    url: '/system/captcha',
    method: 'get',
    params
  })
}

// 用户登录
export function login(params) {
  return request({
    url: '/sys/sys/login',
    // method: 'get',
    method: 'get',
    params
  })
  // return Promise.resolve({ token: '1234567890' })
}

export function modifyPassword(params) {
  return request({
    url: '/system/modifyPwd',
    method: 'post',
    data: params
  })
}

// 退出登录
export function logout(params) {
  return request({
    url: '/system/logout',
    method: 'get',
    params
  })
}